var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Entity, Index, PrimaryColumn } from 'typeorm';
let Worker = class Worker {
    id;
    createdDate;
    tag;
    tick;
    status;
    error;
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], Worker.prototype, "id", void 0);
__decorate([
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Worker.prototype, "createdDate", void 0);
__decorate([
    Index(),
    Column({ unique: true }),
    __metadata("design:type", String)
], Worker.prototype, "tag", void 0);
__decorate([
    Index(),
    Type(() => Date),
    Column({ type: 'timestamp' }),
    __metadata("design:type", Date)
], Worker.prototype, "tick", void 0);
__decorate([
    Index(),
    Column({ type: 'enum', enum: ['started', 'stopped', 'failed'] }),
    __metadata("design:type", String)
], Worker.prototype, "status", void 0);
__decorate([
    Column('jsonb', { nullable: true }),
    __metadata("design:type", Object)
], Worker.prototype, "error", void 0);
Worker = __decorate([
    Entity()
], Worker);
export { Worker };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid29ya2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2RvbWFpbi9tb2RlbHMvd29ya2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUN6QyxPQUFPLEVBQUUsTUFBTSxFQUFFLGdCQUFnQixFQUFFLE1BQU0sRUFBRSxLQUFLLEVBQUUsYUFBYSxFQUFFLE1BQU0sU0FBUyxDQUFDO0FBSzFFLElBQU0sTUFBTSxHQUFaLE1BQU0sTUFBTTtJQUVqQixFQUFFLENBQVU7SUFJWixXQUFXLENBQVE7SUFJbkIsR0FBRyxDQUFVO0lBS2IsSUFBSSxDQUFRO0lBSVosTUFBTSxDQUFnQjtJQUd0QixLQUFLLENBQXNDO0NBQzVDLENBQUE7QUFyQkM7SUFEQyxhQUFhLENBQUMsTUFBTSxFQUFFLEVBQUUsT0FBTyxFQUFFLEdBQUcsRUFBRSxDQUFDLFVBQVUsRUFBRSxDQUFDOztrQ0FDekM7QUFJWjtJQUZDLGdCQUFnQixDQUFDLEVBQUUsSUFBSSxFQUFFLGFBQWEsRUFBRSxDQUFDO0lBQ3pDLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUM7OEJBQ0gsSUFBSTsyQ0FBQztBQUluQjtJQUZDLEtBQUssRUFBRTtJQUNQLE1BQU0sQ0FBQyxFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsQ0FBQzs7bUNBQ1o7QUFLYjtJQUhDLEtBQUssRUFBRTtJQUNQLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUM7SUFDaEIsTUFBTSxDQUFDLEVBQUUsSUFBSSxFQUFFLFdBQVcsRUFBRSxDQUFDOzhCQUN2QixJQUFJO29DQUFDO0FBSVo7SUFGQyxLQUFLLEVBQUU7SUFDUCxNQUFNLENBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLElBQUksRUFBRSxDQUFDLFNBQVMsRUFBRSxTQUFTLEVBQUUsUUFBUSxDQUFDLEVBQUUsQ0FBQzs7c0NBQzNDO0FBR3RCO0lBREMsTUFBTSxDQUFDLE9BQU8sRUFBRSxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsQ0FBQzs7cUNBQ087QUF0QmhDLE1BQU07SUFEbEIsTUFBTSxFQUFFO0dBQ0ksTUFBTSxDQXVCbEIifQ==